import React from 'react';
import { connect } from 'react-redux';

const BusinessChallenge = (props) => {
    return (
      <div className="slds-p-horizontal_medium slds-p-vertical_small" style={{ color: "white"}}>
        How might we {props.companyGoal} by:
        <ul className="slds-list_dotted">
          <li className="slds-p-top_xx-small">{props.measureOne}</li>
          <li className="slds-p-top_xx-small">{props.measureTwo}</li>
          <li className="slds-p-top_xx-small">{props.measureThree}</li>
        </ul>
      </div>
    );
}

const mapStateToProps = (state) => ({
  companyGoal: state.businessChallenge.companyGoal,
  measureOne: state.businessChallenge.measureOne,
  measureTwo: state.businessChallenge.measureTwo,
  measureThree: state.businessChallenge.measureThree,
});

export default connect(mapStateToProps)(BusinessChallenge);
